import { Zoom } from "@mui/material"
import { TransitionProps } from "@mui/material/transitions"
import { forwardRef, ReactElement, Ref } from "react"

export const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>
    },
    ref: Ref<unknown>
) {
    return <Zoom ref={ref} {...props} />
})
